import { ColumnPersonalizationFlags } from 'src/utils/columns/columnUtils.types';
import { Feature } from 'src/WebApiController';

export enum FlightsTableColumnId {
  StartDate = 'startDate',
  Duration = 'duration',
  Campaign = 'campaign',
  EventName = 'eventName',
  EventDate = 'eventDate',
  PotentialRevenue = 'potentialRevenue',
  Revenue = 'revenue',
  Spend = 'spend',
  Roas = 'roas',
  PotentialSales = 'potentialSales',
  SalesCount = 'salesCount',
  HistoricPotentialImpressions = 'historicPotentialImpressions',
  ActualImpressions = 'actualImpressions',
  ImpressionShare = 'impressionShare',
  Clicks = 'clicks',
  Cpc = 'cpc',
  Budget = 'budget',
  BudgetRemaining = 'budgetRemaining',
  Status = 'status',
  Target = 'target',
  IncrementalSellerProceeds = 'incrementalSellerProceeds',
  Actions = 'actions',
}

type FlightsTableColumnPersonalization = Partial<ColumnPersonalizationFlags>;

export const FLIGHTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Partial<
  Record<FlightsTableColumnId, FlightsTableColumnPersonalization>
> = {
  [FlightsTableColumnId.StartDate]: {
    isConfigurable: true,
    isDateTime: true,
  },
  [FlightsTableColumnId.Duration]: {
    isConfigurable: true,
  },
  [FlightsTableColumnId.Campaign]: {
    isConfigurable: true,
    isRequired: false,
  },
  [FlightsTableColumnId.EventName]: {
    isConfigurable: true,
  },
  [FlightsTableColumnId.EventDate]: {
    isConfigurable: true,
    isDateTime: true,
  },
  [FlightsTableColumnId.PotentialRevenue]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.Revenue]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.Spend]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.Roas]: {
    isConfigurable: true,
    isNumeric: true,
    isPercent: true,
  },
  [FlightsTableColumnId.PotentialSales]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [FlightsTableColumnId.SalesCount]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [FlightsTableColumnId.HistoricPotentialImpressions]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [FlightsTableColumnId.ActualImpressions]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [FlightsTableColumnId.ImpressionShare]: {
    isConfigurable: true,
    isNumeric: true,
    isPercent: true,
  },
  [FlightsTableColumnId.Clicks]: {
    isConfigurable: true,
    isNumeric: true,
    isInteger: true,
  },
  [FlightsTableColumnId.Cpc]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.Budget]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.BudgetRemaining]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
  },
  [FlightsTableColumnId.Status]: {
    isConfigurable: true,
  },
  [FlightsTableColumnId.Target]: {
    isConfigurable: true,
  },
  [FlightsTableColumnId.IncrementalSellerProceeds]: {
    isConfigurable: true,
    isNumeric: true,
    isCurrency: true,
    requiredFeatures: [Feature.IncrementalRevenue],
  },
  [FlightsTableColumnId.Actions]: {
    isConfigurable: false,
    isRequired: true,
  },
};
